// components
import { TabPanelProps, TabPanel } from '@mui/lab';
import {
  styled,
  Box,
  Tabs,
  TabsProps,
  BoxProps,
  Chip,
  ChipProps
} from '@mui/material';
import { IconButton } from '@sdb/planning-ui';

export const StyledDrawerTabs = styled(Tabs)<TabsProps>(({ theme }) => ({
  marginTop: theme.spacing(2.5)
}));

export const StyledTabsActionContainer = styled(Box)<BoxProps>(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
}));

export const StyledDrawerTabPanel = styled(TabPanel)<TabPanelProps>(
  ({ theme }) => ({
    padding: theme.spacing(3, 0)
  })
);

export const StyledCompactChip = styled(Chip)<ChipProps>(({ theme }) => ({
  padding: theme.spacing(0, 1)
}));

// Note: should actually be styled for the Tonal variant in the UI kit. This is currently a workaround.
export const StyledTonalIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.vars.palette.secondary.container,
  color: theme.vars.palette.secondary.onContainer,

  '&:hover': {
    backgroundColor: theme.vars.palette.secondary.container
  },

  '& .MuiTouchRipple-root': {
    transition:
      'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
  },
  '&:hover .MuiTouchRipple-root': {
    background: `color-mix(in srgb, ${theme.vars.palette.secondary.onContainer} 8%, transparent)`,
    boxShadow: theme.shadows[1]
  },
  '&:active .MuiTouchRipple-root': {
    background: `color-mix(in srgb, ${theme.vars.palette.secondary.onContainer} 12%, transparent)`,
    boxShadow: theme.shadows[1]
  },
  '&:disabled': {
    backgroundColor: theme.vars.palette.divider,
    color: theme.vars.palette.surface.onSurface
  }
}));
